/**
 * Mamash Organics — Hero Banner Carousel
 * Autoplay, dot nav, keyboard, touch/swipe support.
 * Replaces Framer Motion AnimatePresence from HeroBanner.tsx
 */
(function () {
  'use strict';

  const track = document.getElementById('mamash-hero-track');
  const slides = Array.from(document.querySelectorAll('.mamash-hero-slide'));
  const dots = Array.from(document.querySelectorAll('.mamash-hero-dot'));
  if (!track || slides.length === 0) return;

  let current = 0;
  let timer = null;
  let touchStartX = null;
  const INTERVAL = 5000;

  function goTo(index) {
    slides[current].classList.remove('opacity-100');
    slides[current].classList.add('opacity-0');
    dots[current]?.classList.remove('w-7', 'bg-accent');
    dots[current]?.classList.add('w-2.5', 'bg-foreground/40');

    current = (index + slides.length) % slides.length;

    slides[current].classList.remove('opacity-0');
    slides[current].classList.add('opacity-100');
    dots[current]?.classList.remove('w-2.5', 'bg-foreground/40');
    dots[current]?.classList.add('w-7', 'bg-accent');
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(next, INTERVAL);
  }

  // Dot clicks
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { goTo(i); startTimer(); });
  });

  // Prev / next arrows
  const prevBtn = document.getElementById('mamash-hero-prev');
  const nextBtn = document.getElementById('mamash-hero-next');
  if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { next(); startTimer(); });

  // Touch swipe
  const section = document.getElementById('mamash-hero-section');
  if (section) {
    section.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    section.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? next() : prev(); startTimer(); }
      touchStartX = null;
    }, { passive: true });
  }

  // Keyboard
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { next(); startTimer(); }
    if (e.key === 'ArrowLeft') { prev(); startTimer(); }
  });

  // Pause on hover
  if (section) {
    section.addEventListener('mouseenter', () => clearInterval(timer));
    section.addEventListener('mouseleave', startTimer);
  }

  startTimer();
})();
